// Unpublished Work © 2025 Deere & Company.

import {
    commonErrorAction,
    ErrorHandlerConfig,
} from '../App/utils/errorMessages';

export const chemicalsError: ErrorHandlerConfig = {
    customAction: (error, query) => commonErrorAction(error, query),
};
